import React from 'react';
import { SERVICES } from '../constants.ts';
import { Page } from '../types.ts';

interface ServicesProps {
  limit?: number;
  setPage: (page: Page) => void;
}

const Services: React.FC<ServicesProps> = ({ limit, setPage }) => {
  const displayServices = limit ? SERVICES.slice(0, limit) : SERVICES;

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-14">
      {displayServices.map((service, index) => (
        <div 
          key={index} 
          onClick={() => setPage(service.link)}
          className={`group flex flex-col h-full p-12 lg:p-14 rounded-[64px] bg-white dark:bg-slate-900/40 border border-slate-100 dark:border-slate-800 shadow-premium hover:shadow-premium-hover hover:border-primary/20 hover:-translate-y-4 transition-all duration-700 cursor-pointer animate-reveal stagger-${(index % 4) + 1}`}
        >
          {/* Enhanced Icon Section */}
          <div className="mb-12 relative inline-block">
            <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full scale-0 group-hover:scale-150 transition-transform duration-1000 opacity-0 group-hover:opacity-100"></div>
            <div className="relative w-24 h-24 bg-slate-50 dark:bg-slate-800 text-primary dark:text-accent-300 rounded-[40px] flex items-center justify-center border border-slate-100 dark:border-slate-700 shadow-inner group-hover:bg-primary group-hover:text-white group-hover:rotate-[12deg] transition-all duration-500 ease-out">
              <span className="material-symbols-rounded text-5xl">{service.icon}</span>
            </div>
          </div>

          <div className="flex-1">
            <h3 className="text-3xl lg:text-4xl font-display font-bold text-slate-900 dark:text-white mb-8 group-hover:text-primary transition-colors duration-300 tracking-tight">
              {service.title}
            </h3>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed mb-12 text-xl font-medium">
              {service.description}
            </p>
          </div>

          {/* Action Footer */}
          <div className="mt-auto pt-12 border-t border-slate-50 dark:border-slate-800/60 flex items-center justify-between">
            <div className="flex items-center font-bold text-primary dark:text-accent-400 gap-4 group/btn">
              <span className="text-[11px] uppercase tracking-[0.4em] font-black">Secure Filing</span>
              <div className="flex items-center overflow-hidden w-10">
                <span className="material-symbols-rounded text-3xl -translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-out">arrow_right_alt</span>
              </div>
            </div>
            
            <div className="text-right">
              <p className="text-[10px] font-black uppercase text-slate-400 tracking-widest mb-2">From</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-white font-display">{service.price}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;